"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouterDom = require("react-router-dom");

var _Utils = require("@icare/core/lib/utils/Utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @example
 * <TileNavigation items={[]} name="profile navigation" />
 */
var TileNavigation = /*#__PURE__*/function (_React$Component) {
  _inherits(TileNavigation, _React$Component);

  var _super = _createSuper(TileNavigation);

  function TileNavigation(props) {
    var _this;

    _classCallCheck(this, TileNavigation);

    _this = _super.call(this, props);
    _this._id = (0, _Utils.createGuid)();
    return _this;
  }

  _createClass(TileNavigation, [{
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          tag = _this$props.tag;
      return (items || []).map(function (item, index) {
        var itemClasses = (0, _classnames.default)('tile-navigation__link', 'option', "option-".concat(item.key), _defineProperty({
          active: item.isActive
        }, "option-".concat(item.icon), item.icon));
        var optionalAtt = {};

        if (item.isActive) {
          optionalAtt['aria-current'] = 'page';
        }

        if (item.to) {
          optionalAtt.to = item.to;
        }

        if (item.href) {
          optionalAtt.href = item.href;
        }

        if (typeof item.onClick === 'function') {
          optionalAtt.onClick = function (e) {
            e.preventDefault();
            item.onClick(e, index, item.key);
          };
        }

        return /*#__PURE__*/_react.default.createElement("li", {
          key: item.key,
          className: "tile-navigation__item"
        }, /*#__PURE__*/_react.default.createElement(tag, _objectSpread({
          className: itemClasses,
          'aria-label': item.title,
          'aria-describedby': "".concat(_this2._id, "_").concat(index)
        }, optionalAtt), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          className: "tile-navigation__title h4"
        }, item.title), item.intro && /*#__PURE__*/_react.default.createElement("span", {
          className: "tile-navigation__intro",
          id: "".concat(_this2._id, "_").concat(index)
        }, item.intro))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var name = this.props.name;
      return /*#__PURE__*/_react.default.createElement("nav", {
        "aria-label": name
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "tile-navigation"
      }, this.renderItems()));
    }
  }]);

  return TileNavigation;
}(_react.default.Component);

TileNavigation.defaultProps = {
  items: [],
  name: 'tile-navigation',
  tag: _reactRouterDom.Link
};
TileNavigation.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    intro: _propTypes.default.string,
    isActive: _propTypes.default.bool,
    to: _propTypes.default.string,
    href: _propTypes.default.string,
    icon: _propTypes.default.string
  })),
  name: _propTypes.default.string.isRequired,
  tag: _propTypes.default.elementType
};
var _default = TileNavigation;
exports.default = _default;
//# sourceMappingURL=TileNavigation.js.map